export function LoadingScreen() {
  return (
    <div className="flex h-full items-center justify-center">
      <div
        role="status"
        aria-label="Loading"
        className="h-10 w-10 animate-spin rounded-full border-2 border-gp-border border-t-gp-button"
      />
    </div>
  );
}
